export const SERVER_BASE_URL = "https://crossfitleaderboard.gainlineopen.co.uk/"
// export const SERVER_BASE_URL = "http://localhost:5158/"